import React, { useContext } from 'react';
import { getContext } from 'common';
import { TabsContext } from './Tabs';
import Styled from './styles';

export interface TabIconProps {
  disabled?: boolean,
  selected?: boolean,
  children?: React.ReactNode,
  theme?: any
}

/** Wraps Icon components for Tabs. All props will be provided to the wrapper element */
const TabIcon = React.forwardRef<HTMLElement, TabIconProps>((props: TabIconProps, ref) => getContext(({ RTL }) => {
  const tabsContext = useContext(TabsContext);
  const isRTL = tabsContext.rtl || RTL;
  return (
    <Styled.TabIcon ref={ref} {...props} rtl={isRTL} $disableAnimation={tabsContext.disableAnimation}>
      {props.children}
    </Styled.TabIcon>
  );
}));

TabIcon.displayName = 'TabIcon';
TabIcon.defaultProps = {
  disabled: false,
  selected: false,
  children: undefined,
  theme: {}
};

export { TabIcon as default };
